module.exports = __webpack_public_path__ + "static/media/influence_targaryen.027b7bf2.png";